import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import OtherInformation from './components/OtherInformation';
import * as CommonService from '../../../services/CommonService';

import { CUSTOMER_ENDPOINT } from '../../../services/endpoint';

import { Button, Col, message, Modal, Row } from 'antd';
import CustomerInformation from './components/CustomerInformation';
import PurchaseInformation from './components/PurchaseInformation';

export default () => {

	const { id } = useParams();

	const history = useHistory();

	const [customer, setCustomer] = useState({});
	const [reload, setReload] = useState(0);

	useEffect(() => {
		const init = async () => {
			try {
				window.setLoading(true);
				const resp = await CommonService.findById(CUSTOMER_ENDPOINT, id);
				setCustomer(resp.data || {});
			} catch (error) {
				message.error(error?.data?.message);
			} finally {
				window.setLoading(false);
			}
		};
		init();
	}, []);

	const back = () => {
		history.push('/customer');
	};

	const gotoEdit = (id) => {
		history.push('/customer/edit/' + id);
	};

	const handleDelete = (id) => {
		window.setLoading(true);
		CommonService.deleteRecord(CUSTOMER_ENDPOINT, id).then(() => {
			back();
			message.success('Xóa khách hàng thành công');
		}).catch(err => {
			message.error(err?.data?.message);
		}).finally(() => {
			window.setLoading(false);
		});
	};

	const [isModalOpen, setIsModalOpen] = useState(false);

	const showModal = () => {
		setIsModalOpen(true);
	};
	const handleOk = () => {
		setIsModalOpen(false);
		handleDelete(id);
	};
	const handleCancel = () => {
		setIsModalOpen(false);
	};

	return <div id={'product-detail-page'}>
		<Row gutter={12}>
			<Col>
				<CustomerInformation customer={customer} showModal={showModal} gotoEdit={gotoEdit} setReload={setReload} />
			</Col>
			<br />
			<Col span={24}>
				<PurchaseInformation customer={customer} />
			</Col>
			<Col span={24}>
				<OtherInformation customer={customer} reload={reload} />
			</Col>
		</Row>
		<Modal
			title="Xóa khách hàng"
			visible={isModalOpen}
			onOk={handleOk}
			onCancel={handleCancel}
		>
			<p>Bạn có chắc chắn muốn xóa khách hàng <b>{customer.name}</b>? Thao tác này không thể khôi phục.</p>
		</Modal>
	</div>;
}
